
import Vue from 'vue'
import {ListingDetailInterface, ChefExtraOptionInterface, ChefPricingInterface} from '~/store/listing'
import {clone, find, findIndex} from 'lodash'
import {EVENT_CHANGE_DATA, EVENT_CHANGE_PERSONS} from '~/util/event-bus'
import {mapGetters} from "vuex";

export interface ExtraSelectedInterface {
  id: number
  value: number
}

export default Vue.extend({
  name: 'ChefExtraCard',
  props: {
    chefIdOrSlug: {
      type: String,
      default: '',
      required: true
    },
    error: {
      type: String,
      required: false
    }
  },
  data(): {
    showFullList: boolean;
    showOnlyForGroupPopup: boolean;
  } {
    return {
      showFullList: false,
      showOnlyForGroupPopup: false,
    }
  },
  computed: {
    ...mapGetters({
      filter: 'filter/filter',
    }),
    list(): ChefExtraOptionInterface[] {
      if (this.showFullList) {
        return this.chef.extras
      }

      return this.chef.extras.slice(0, 3)
    },
    selectedItems(): ExtraSelectedInterface[] {
      return this.$store.getters['listing/extraByListingId'](this.chef.id) ?? [];
    },
    chef(): ListingDetailInterface {
      return this.$store.getters['listing/byIdOrSlug'](this.chefIdOrSlug)
    },
    price(): ChefPricingInterface {
      return this.$store.getters['listing/pricingByListingId'](this.chef.id)
    },
  },
  methods: {
    selectedExtra(id: number): ChefExtraOptionInterface | null {
      let selectedExtra = null;
      this.chef.extras.forEach(extra => {
        if (extra.id === id) {
          selectedExtra = extra;
          return;
        }
      })

      return selectedExtra
    },
    createOrGet(index: number) {
      const item = findIndex(this.selectedItems, {
        id: index
      })

      if (item === -1) {
        this.$store.commit('listing/UPDATE_SELECTED_EXTRA', {
          key: this.chef.id,
          data: [
            ...this.selectedItems,
            {
              id: index,
              value: 0
            }
          ],
        })

        return findIndex(this.selectedItems, {
          id: index
        });
      }

      return item
    },
    selectAndDeselect(index: number) {
      const itemIndex = this.createOrGet(index)
      const items = clone(this.selectedItems);

      this.$set(items, itemIndex, {
        ...items[itemIndex],
        value: items[itemIndex].value > 0 ? 0 : this.filter.person
      });

      this.$store.commit('listing/UPDATE_SELECTED_EXTRA', {
        key: this.chef.id,
        data: [...items]
      });

      this.$nuxt.$emit(EVENT_CHANGE_DATA, {});
    },
    value(index: number) {
      return find(this.selectedItems, {
        id: index
      })?.value ?? 0
    },
    increment(index: number) {
      const itemIndex = this.createOrGet(index)
      const items = clone(this.selectedItems);

      this.$set(items, itemIndex, {
        ...items[itemIndex],
        value: items[itemIndex].value + 1
      });

      this.$store.commit('listing/UPDATE_SELECTED_EXTRA', {
        key: this.chef.id,
        data: [...items]
      });

      this.$nuxt.$emit(EVENT_CHANGE_DATA, {});
    },
    decrement(index: number) {
      const itemIndex = this.createOrGet(index)
      const items = clone(this.selectedItems);

      if (items[itemIndex].value > 0) {
        this.$set(items, itemIndex, {
          ...items[itemIndex],
          value: items[itemIndex].value - 1
        });

        this.$store.commit('listing/UPDATE_SELECTED_EXTRA', {
          key: this.chef.id,
          data: [...items]
        });

        this.$nuxt.$emit(EVENT_CHANGE_DATA, {});
      }
    }
  },
  async mounted() {
    // Update number of persons for extras that are only for the whole group
    this.$nuxt.$on(EVENT_CHANGE_PERSONS, () => {
      const items = clone(this.selectedItems);

      items.forEach((item, itemIndex) => {
        const selectedExtra = this.selectedExtra(item.id);
        if (!selectedExtra) {
          return;
        }

        if (!selectedExtra.quantity_buttons) {
          this.$set(items, itemIndex, {
            ...items[itemIndex],
            value: this.filter.person
          });
        }
      });

      this.$store.commit('listing/UPDATE_SELECTED_EXTRA', {
        key: this.chef.id,
        data: [...items]
      });
    })
  },
  beforeDestroy() {
    this.$nuxt.$off(EVENT_CHANGE_PERSONS)
  },
})
